export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14517.4d08c2aa.jpg";